<template>
  <el-dialog
    :model-value="flagVisible" width="36%"
    :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false"
  >
    <div class="modal-container">
      <div class="modal-title">
        <span>Welcome to the ATK Player!</span>
      </div>
      <div class="modal-text">
        <span>Your account has been created and your password is set.</span>
      </div>
      <div class="modal-text">
        <span>Let’s finish setting up your profile.</span>
      </div>
      <div class="modal-form">
        <div class="form-actions">
          <el-button class="el-btn-blue" @click="redirectToProfile">Create Profile</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: [],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    redirectToProfile: function (val) {
      this.$router.push({ path: '/client/profile' })
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  padding: 0 60px 30px;
  color: black;
  .modal-title {
    font-size: 22px;
    font-weight: bold;
  }
  .modal-text {
    font-size: 16px;
    margin-top: 20px;
  }
  .modal-form {
    margin-top: 58px;
    .form-actions {
      text-align: center;
    }
  }
}
</style>
